<template>
  <div>
    <new-cv-popup
      :data-to-show="stepNewCvPopupDisplayed"
      :errors="errorsCreateNewCv"
      @close="displayPopupNewCV(-1)"
      @createNewCv="(infos) => {newCV(infos)}"
      @changePage="(step) => stepNewCvPopupDisplayed = step"
    />

    <h6 class="lg:mx-52 text-gray-600">
      Votre espace CV est vierge.
    </h6>
    <h6 class="lg:mx-52 text-gray-600 mt-5">
      Pour créer votre premier CV, cliquer sur le bouton "Créer mon premier CV"
    </h6>

    <div class="flex justify-center mt-15">
      <action-button
        id="create-cv"
        border-color="border-transparent"
        text-color="text-white"
        bg-color="bg-indigo-600"
        bg-color-square="bg-indigo-600"
        icon-color="text-white"
        libelle="Créer mon premier CV"
        :uppercase="true"
        icon="plus-circle"
        type-shadow="indigo-shadow"
        @clickAction="displayPopupNewCV(1)"
      />
    </div>

    <div class="flex justify-center mt-10">
      <illustration name="evaluation" />
    </div>
  </div>
</template>

<script>
import ActionButton from '../../components/ActionButton.vue';
import Illustration from '../../components/Illustration.vue';
import NewCvPopup from './popup/NewCvPopup.vue';

export default {
  components:{
    ActionButton,
    Illustration,
    NewCvPopup
  },

  data(){
    return {
      errorsCreateNewCv:{},
      stepNewCvPopupDisplayed: -1,
    };
  },

  methods:{
    displayPopupNewCV(step){
      this.stepNewCvPopupDisplayed = step;
    },

    newCV(infos){
      this.$emit('newCV', infos);
    }
  }

};
</script>
